module.exports = __webpack_public_path__ + "img/1557395456.db5cb8e7.jpg";